export class DerTotalsData  {
    constructor() {
    }
    State : string = "";
    RatedCapacity : number = 0;
    StorageCapacity : number = 0;
    Source : string = "OTHER";
    NoOfUnits : number = 0;
    InstallationType : string = "OTHER";
    Colour : string  = "";
}
export class DerData  {
    constructor() {
    }
    Period : number = 1000;
    State : string = ""
    RatedCapacity : number = 0;
    StorageCapacity : number = 0;
    Source : string = "OTHER";
    NoOfUnits : number = 0;
    InstallationType : string = "OTHER";
    Colour : string  = "";
    LabelColour : string = "";
}



// WEBPACK FOOTER //
// src/views/electricity/der/der-data.ts